import classnames from 'classnames/bind'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './help_text.module.scss'

const cx = classnames.bind(styles)

const HelpText = ({ className, children, intentBg, intentText }) => {
  const wrapClassName = cx(className, styles.helpText, {
    bgPrimary: intentBg === 'primary',
    bgDanger: intentBg === 'danger',
    textDefault: !intentText,
    textPrimary: intentText === 'primary',
    textDanger: intentText === 'danger'
  })

  return <div className={wrapClassName}>{children}</div>
}

HelpText.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  intentBg: PropTypes.string,
  intentText: PropTypes.string
}

HelpText.defaultProps = {
  className: null,
  intentBg: 'primary',
  intentText: null
}

export default HelpText
